import React from 'react'
import { Avatar, FavoriteBadge } from '@paypalcorp/pp-react'

const LATIN_REGEX = /^[A-z\u00C0-\u00ff\s'\.,-\/#!$%\^&\*;:{}=\-_`~()]+$/

type Props = {
  size?: 'xs' | 'sm' | 'md' | 'lg',
  imageUrl?: string,
  altText?: string,
  firstInitial?: string,
  lastInitial?: string,
  isBusiness?: boolean,
  color?: 'magenta' | 'yellow' | 'green' | 'purple',
  isFavorite?: boolean, // TODO
}
export default function ContactAvatar(props: Props) {
  const {
    size = 'md',
    imageUrl,
    altText,
    isBusiness = false,
    firstInitial,
    lastInitial,
    color = 'magenta',
    isFavorite = false,
  } = props

  const avatarProps = {
    size,
    'aria-hidden': true,
  }
  if (imageUrl) {
    avatarProps.src = imageUrl
    avatarProps.alt = ''
    if (altText) {
      avatarProps.alt = altText
    }
  } else if (
    // show initials IFF both initials present AND both are latin characters
    firstInitial &&
    lastInitial &&
    LATIN_REGEX.test(firstInitial) &&
    LATIN_REGEX.test(lastInitial)
  ) {
    avatarProps.initials = firstInitial + lastInitial
    avatarProps.color = color
  } else if (isBusiness) {
    avatarProps.generic = 'merchant'
  } else {
    avatarProps.generic = 'profile'
  }

  if (isFavorite) {
    avatarProps.badge = <FavoriteBadge data-testid="contact-avatar-favorite" />
  }

  return <Avatar {...avatarProps} />
}
